import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  interfaceCoverage: [] as any[], // Q2 rows, TOTAL row excluded
  interfaceCoverageTotals: null as any, // Q2 TOTAL row
  isInterfaceCoverageLoading: false,
  familiesOverviewByInterface: null as any, // Q1 detail for the currently-viewed interface (fetched per backend_interface_id)
  isFamiliesOverviewLoading: false,
  brandStepCoverage: [] as any[], // Q3 rows
  isBrandStepCoverageLoading: false,
  needsAttentionRows: [] as any[], // Q4 rows (row_type: family | step_summary | total)
  isNeedsAttentionLoading: false,
};

const familiesSlice = createSlice({
  name: "families",
  initialState,
  reducers: {
    setInterfaceCoverage: (state, action) => {
      state.interfaceCoverage = action.payload.rows;
      state.interfaceCoverageTotals = action.payload.totals;
    },
    setIsInterfaceCoverageLoading: (state, action) => {
      state.isInterfaceCoverageLoading = action.payload;
    },
    setFamiliesOverviewByInterface: (state, action) => {
      state.familiesOverviewByInterface = action.payload;
    },
    setIsFamiliesOverviewLoading: (state, action) => {
      state.isFamiliesOverviewLoading = action.payload;
    },
    setBrandStepCoverage: (state, action) => {
      state.brandStepCoverage = action.payload;
    },
    setIsBrandStepCoverageLoading: (state, action) => {
      state.isBrandStepCoverageLoading = action.payload;
    },
    setNeedsAttentionRows: (state, action) => {
      state.needsAttentionRows = action.payload;
    },
    setIsNeedsAttentionLoading: (state, action) => {
      state.isNeedsAttentionLoading = action.payload;
    },
  },
});

export const {
  setInterfaceCoverage,
  setIsInterfaceCoverageLoading,
  setFamiliesOverviewByInterface,
  setIsFamiliesOverviewLoading,
  setBrandStepCoverage,
  setIsBrandStepCoverageLoading,
  setNeedsAttentionRows,
  setIsNeedsAttentionLoading,
} = familiesSlice.actions;

export default familiesSlice.reducer;
